import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/estadio.png'


const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-7xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-2 md:text-2xl text-lg" }, "Completá tus datos y te enviaremos la entrada digital al celular y correo electrónico indicado."),
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-2 md:text-2xl text-lg" }, "Podrás acceder al estadio a partir de las 10:00hs con tu entrada digital y el DNI correspondiente."),
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-2 md:text-2xl text-lg" }, "Por cada registro recibirás una entrada que te permitirá acceder a los dos partidos.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-2 flex flex-col items-center max-h-full" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "max-h-full object-contain max-w-xs",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-4" }, "Por favor completá el formulario en su totalidad y podrás disfrutar del partido")
], -1)
const _hoisted_6 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_7 = { class: "w-full px-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Sector", -1)
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_11 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)
const _hoisted_13 = { class: "text-sm text-red-500 p-error" }
const _hoisted_14 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "DNI", -1)
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_21 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Dirección", -1)
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Localidad", -1)
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_28 = { class: "w-full px-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Institución que te invita", -1)
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_32 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Mail", -1)
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)
const _hoisted_37 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)
const _hoisted_39 = { class: "text-sm text-red-500 p-error" }
const _hoisted_40 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)
const _hoisted_42 = { class: "text-sm text-red-500 p-error" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mt-5 text-sm" }, "• RECORDÁ QUE NO ES NECESARIO IMPRIMIR EL TICKET", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mt-5 text-sm" }, "• CON EL REGISTRO DECLARO ACEPTAR LOS SIGUIENTES TÉRMINOS Y CONDICIONES", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap py-2 text-xs" }, " Las Entradas se entregan al Destinatario en carácter de protocolo motivo por el cual cualquier tipo de comercialización y/o venta de las mismas se encuentra terminantemente prohibida. El Destinatario será el único responsable del incumplimiento de dicha prohibición, inclusive por parte de aquellos beneficiarios que el Destinatario no hubiera identificado. Las Entradas podrán ser únicamente para uso del Destinatario, sus directivos y/o para fines promocionales y de protocolo. El Destinatario deberá cumplir con todas las regulaciones y leyes vigentes incluyendo, pero no limitando a las regulaciones federales, provinciales, de la Asociación del Futbol Argentino, ligas provinciales de futbol, organismos federales y/o provinciales de seguridad deportiva y cualquier otro organismo de seguridad de aplicación, así como con las regulaciones sanitarias vigentes. El Destinatario declara y asegura que utilizará las Entradas conforme lo establecido en el presente documento, comprometiéndose a no destinar las Entradas para pagar, ofrecer, prometer o autorizar el pago, directa o indirectamente a cualquier persona o entidad, a fin de influenciar cualquier acto o decisión o para realizar cualquier pago indebido a cualquier Funcionario Público, Oficial Deportivo o a cualquier otro individuo privado. Siendo el Destinatario único responsable ante cualquier incumplimiento con la normativa vigente aplicable, y/o lo establecido en el presente documento, debiendo mantener indemne a Torneos y la AFA ante cualquier reclamo y/o acción en la que se pudiera ver involucrada. ", -1)
const _hoisted_46 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_49 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, {
                name: "sector",
                modelValue: _ctx.formData.sector,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.sector) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccioná el sector",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.sectores,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "sector" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Nombre"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Apellido"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Field, {
                name: "dni",
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.dni) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "DNI"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_ErrorMessage, { name: "dni" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Field, {
                name: "direccion",
                modelValue: _ctx.formData.direccion,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.direccion) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "direccion",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_ErrorMessage, { name: "direccion" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_Field, {
                name: "localidad",
                modelValue: _ctx.formData.localidad,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.localidad) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Localidad"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_ErrorMessage, { name: "localidad" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Field, {
                name: "institucionReferencia",
                modelValue: _ctx.formData.institucionReferencia,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.institucionReferencia) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "institucionReferencia",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_ErrorMessage, { name: "institucionReferencia" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_Field, {
                name: "mail",
                modelValue: _ctx.formData.mail,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.mail) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_34, [
                    _createVNode(_component_ErrorMessage, { name: "mail" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.formData.countryCode,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.countryCode) = $event)),
                class: "w-full p-inputtext-sm p-3",
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_Field, {
                name: "codigoArea",
                modelValue: _ctx.formData.codigoArea,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Sin 0 adelante"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_39, [
                    _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(_component_Field, {
                name: "telefonoCelular",
                modelValue: _ctx.formData.telefonoCelular,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_42, [
                    _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _hoisted_43,
          _hoisted_44,
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              type: "submit",
              label: "REGISTRARME",
              class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_48, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_49, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _createTextVNode("REGISTRARME ")
            ], 8, _hoisted_47)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}